import apiClient from './api'

const departmentJobService = {
  // Get all department jobs
  async getDepartmentJobs(params = {}) {
    try {
      params['_no_pagination_'] = 1
      params['_with_[department]'] = ''
      const response = await apiClient.get('/admin/department-jobs', { params })
      return response
    } catch (error) {
      console.error('Error fetching department jobs:', error)
      throw error
    }
  },

  // Create new department job
  async createDepartmentJob(data) {
    try {
      const response = await apiClient.post('/admin/department-jobs', data)
      return response
    } catch (error) {
      console.error('Error creating department job:', error)
      throw error
    }
  },

  // Update department job
  async updateDepartmentJob(id, data) {
    try {
      const response = await apiClient.put(`/admin/department-jobs/${id}`, data)
      return response
    } catch (error) {
      console.error('Error updating department job:', error)
      throw error
    }
  },

  // Delete department job
  async deleteDepartmentJob(id) {
    try {
      const response = await apiClient.delete(`/admin/department-jobs/${id}`)
      return response
    } catch (error) {
      console.error('Error deleting department job:', error)
      throw error
    }
  }
}

export default departmentJobService 